import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type SettlementAmount = {
  settlement_amount_id?: number; // 정산 idx
  company_name?: string; // 업체명
  sale_num?: number; // 판매수량
  sale_price?: number; // 판매금액
  commission_rate?: number; // 수수료율
  settlement_amount_price?: number; // 정산금액
  vat?: number; // 부가세
  settlement_amount_status?: string; // 정산상태
  parcel_service_id?: number; // 배송/정기배송 idx
  rental_id?: number; // 렌탈 idx
  order_reservation_id?: number; // 오더/예약 idx
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] SettlementAmount
   * --
   */
  getSettlementAmounts: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SETTLEMENT_AMOUNT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] SettlementAmount
   * --
   */
  getSettlementAmount: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SETTLEMENT_AMOUNT, {
        settlement_amount_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] SettlementAmount
   * --
   */
  createSettlementAmount: async (body: SettlementAmount) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SETTLEMENT_AMOUNT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] SettlementAmount
   * --
   */
  updateSettlementAmount: async (body: SettlementAmount) => {
    try {
      const { settlement_amount_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SETTLEMENT_AMOUNT, {
        settlement_amount_id: settlement_amount_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] 일괄업데이트 SettlementAmount
   * --
   */
  bulkUpdateSettlementAmount: async (body: SettlementAmount[]) =>
    $http.put(APIConstant.BULK_UPDATE_SETTLEMENT_AMOUNT, body),

  /**
   * [DELETE] SettlementAmount
   * --
   */
  deleteSettlementAmount: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SETTLEMENT_AMOUNT, {
        settlement_amount_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
